import { Card, Button, Typography, Form } from 'antd'
import React, { useState, useEffect } from 'react'
import '../Style/blogStyle.scss'

const { Title } = Typography

interface ExcerptCardProps {
  value?: string
  onChange?: (value: string) => void
}

const ExcerptCard = ({ value, onChange }: ExcerptCardProps) => {
  const [showEditor, setShowEditor] = useState(!!value)
  const [excerpt, setExcerpt] = useState(value || '')
  const MAX_CHARS = 2000

  // Sync with parent value when it changes
  useEffect(() => {
    setExcerpt(value || '')
    // Show editor if there's a value, hide if empty or undefined
    setShowEditor(!!value)
  }, [value])

  const handleExcerptChange = (newValue: string) => {
    setExcerpt(newValue)
    onChange?.(newValue)
  }

  const handleRemoveExcerpt = () => {
    setExcerpt('')
    setShowEditor(false)
    onChange?.('')
  }
  return (
    <Card style={{ marginBottom: '24px', borderColor: '#E1E3E3', backgroundColor: '#F5F6F8', padding: '20px' }}>
      <Title level={5} style={{ fontSize: '16px', fontWeight: '600', marginBottom: '6px' }}>
        Excerpt
      </Title>

      <p style={{ fontWeight: '400', fontSize: '14px', marginTop: '10px' }}>
        Add a summary of the post to appear on your homepage or blog.
      </p>

      {!showEditor && (
        <Button
          type="link"
          className="add-excerpt"
          onClick={() => setShowEditor(true)}
        >
          Add excerpt
        </Button>
      )}
      {showEditor && (
        <>
          <div className="excerpt-editor">
            <Form.Item
              name="excerpt"
              // rules={[
              //   { required: true, message: 'Please add an excerpt' },
              //   {
              //     validator: (_, value) => {
              //       const text = value?.replace(/<[^>]*>/g, '') || ''
              //       if (text.trim().length < 10) {
              //         return Promise.reject('Excerpt must be at least 10 characters long')
              //       }
              //       if (text.length > 2000) {
              //         return Promise.reject('Excerpt cannot exceed 2000 characters')
              //       }
              //       return Promise.resolve()
              //     }
              //   }
              // ]}
            >
              <textarea
                value={excerpt}
                onChange={(e) => handleExcerptChange(e.target.value)}
                placeholder="Write an excerpt..."
                style={{ width: '100%', height: '190px', padding: '12px', borderRadius: '8px', border: '1px solid #E1E3E3', fontSize: '14px', resize: 'none' }}
              />
            </Form.Item>
          </div>
          <div className="excerpt-footer">
            <span>{MAX_CHARS - excerpt?.length} characters remaining</span>
          </div>
          <Button
            className="remove-excerpt"
            onClick={handleRemoveExcerpt}
          >
            Remove excerpt
          </Button>
        </>
      )}

    </Card>
  )
}

export default ExcerptCard
